import { DesktopFlyoutMenuComponent } from '../components/desktop-flyout-menu/desktop-flyout-menu.component';
import { DesktopMegaMenuComponent } from '../components/desktop-mega-menu/desktop-mega-menu.component';
import { MobileMegaMenuComponent } from '../components/mobile-mega-menu/mobile-mega-menu.component';
import { AccordionComponent } from '../snippet/accordion/accordion.component';
import { ButtonComponent } from '../snippet/button/button.component';
import { CardComponent } from '../snippet/card/card.component';
import { FeatureComponent as SnippetFeatureComponent } from '../snippet/feature/feature.component';
import { ImageComponent } from '../snippet/image/image.component';
import { LinkComponent } from '../snippet/link/link.component';
import { MenuComponent } from '../snippet/menu/menu.component';
import { MessageComponent } from '../snippet/message/message.component';
import { RichtextComponent } from '../snippet/richtext/richtext.component';
import { TallyComponent } from '../snippet/tally/tally.component';
import { VideoComponent } from '../snippet/video/video.component';
import { CallOutComponent } from './call-out/call-out.component';
import { CollectionComponent as CollectionListComponent } from './collection/collection.component';
import { ContactFormComponent } from './contact-form/contact-form.component';
import { DisplayTextComponent } from './display-text/display-text.component';
import { FaqsComponent } from './faqs/faqs.component';
import { FeatureComponent } from './feature/feature.component';
import { FeaturedArticlesComponent } from './featured-articles/featured-articles.component';
import { GridComponent } from './grid/grid.component';
import { HeroComponent } from './hero/hero.component';
import { InfoSheetComponent } from './info-sheet/info-sheet.component';
import { PageComponent } from './page/page.component';
import { PosterComponent } from './poster/poster.component';
import { ReviewCalloutComponent } from './review-callout/review-callout.component';
import { ShopByComponent } from './shop-by/shop-by.component';
import { TickerComponent } from './ticker/ticker.component';
import { USPSComponent } from './usps/usps.component';

let Components = {
  page: PageComponent,
  hero: HeroComponent,
  grid: GridComponent,
  ticker: TickerComponent,
  'collection-list': CollectionListComponent,
  poster: PosterComponent,
  'review-callout': ReviewCalloutComponent,
  'shop-by': ShopByComponent,
  'call-out': CallOutComponent,
  usps: USPSComponent,
  faqs: FaqsComponent,
  feature: FeatureComponent,
  'featured-articles': FeaturedArticlesComponent,
  'mobile-mega-menu': MobileMegaMenuComponent,
  'desktop-mega-menu': DesktopMegaMenuComponent,
  'desktop-flyout-menu': DesktopFlyoutMenuComponent,
  'display-text': DisplayTextComponent,
  'info-sheet': InfoSheetComponent,
  'contact-form': ContactFormComponent,
  's-feature': SnippetFeatureComponent,
  's-card': CardComponent,
  's-message': MessageComponent,
  's-image': ImageComponent,
  's-button': ButtonComponent,
  's-menu': MenuComponent,
  's-link': LinkComponent,
  's-grid': GridComponent,
  's-accordion': AccordionComponent,
  's-richtext': RichtextComponent,
  's-video': VideoComponent,
  's-tally': TallyComponent,
};

export { Components };
